export const SUPPLIERS_QUERY = '/supplier';
export const CONNECTION_VIEWS_QUERY = '/connectionviews';
export const SUPPLIED_PRODUCTS_QUERY = '/suppliers/products';
